import { render } from "./BecomePartner.vue?vue&type=template&id=5f746676"
import script from "./BecomePartner.vue?vue&type=script&lang=js"
export * from "./BecomePartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__